import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {UniversalSearchResultModel} from '../../models/universal-search-result.model';
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {SearchService} from '../../services/search.service';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'morva-universal-search',
  templateUrl: './universal-search.component.html',
  styleUrls: ['./universal-search.component.scss'],
  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({ opacity: 0, width: '0' }),
        animate('500ms', style({ opacity: 1, width: 'inherit'})),
      ]),
      transition(':leave', [
        style({ opacity: 1, width: '100%' }),
        animate('500ms', style({ opacity: 0, width: '0' })),
      ]),
    ]),
    trigger('openClose', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1})),
      ]),
      transition(':leave', [
        animate('300ms', style({ opacity: 0})),
      ]),
    ]),
  ],
})
export class UniversalSearchComponent implements OnInit, AfterViewInit {

  @Input() left: number;
  @Input() top: number;
  @Input() expandable = true;
  @Output() focuseOutEmitter = new EventEmitter();

  @ViewChild('input') input: ElementRef;
  @ViewChild('searchIcon', { read: ElementRef }) searchIcon: ElementRef;

  slidedIn: boolean;
  searchKey: string;

  searchResult: UniversalSearchResultModel[] = [];

  showResult = false;

  constructor(private searchApi: SearchService, private router: Router, private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.slidedIn = true;
  }


  ngAfterViewInit() {
    fromEvent(this.input.nativeElement,'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(600),
        distinctUntilChanged(),
        tap((text) => {
          const searchKey = this.input.nativeElement.value;
          if(searchKey.length > 0) {
            this.search(searchKey);
          }else{
            this.searchResult = [];
            this.showResult = false;
          }
        }),
      )
      .subscribe();
  }

  search(searchKey: string){
    this.searchApi.search(searchKey).subscribe(
      (searchResult) => {
        if(searchResult.data.length > 0){
          this.searchResult = searchResult.data;
        }else{
          this.searchResult = [];
        }
        this.showResult = true;
        this.changeDetectorRef.detectChanges();
      },
    );
  }

  onFocusOut($event) {
    if($event.relatedTarget === this.searchIcon.nativeElement){
      this.input.nativeElement.focus();
    } else if(!$event.path?.find(pathTemp => pathTemp === 'search-results-list')){
      this.emitFocusOutEmitter();
      this.clearSearchKey();
      this.showResult = false;
    }
  }

  onFocusIn($event) {
    if (this.input.nativeElement.value.length > 0) {
      this.showResult = true;
    }
  }

  clearSearchKey() {
    this.input.nativeElement.value = '';
    this.emitFocusOutEmitter();
    this.showResult = false;
  }

  emitFocusOutEmitter(): void {
    if(this.expandable) {
      this.slidedIn = false;
    }
    setTimeout(() => this.focuseOutEmitter.emit(), 500);
  }
}
